import React from 'react';
import { Footer } from '../FormComponents';
import styles from './index.scss';
import { useMobileMedia } from '@xo-union/tk-ui-breakpoints';
import { H2 } from '@xo-union/tk-ui-typography';
import { Select, Option } from '@xo-union/tk-component-fields';
import { FormColumn, FormRow } from '@xo-union/tk-component-form-grid';
import { Field as UnionField } from '@xo-union/tk-component-fields';

interface Props {
  domainName: string;
  tld: string;
  onCancel: () => void;
  onConfirm: () => void;
}

const MatchedDomain: React.FC<Props> = ({ domainName, tld, onCancel, onConfirm }) => {
  const mobileMedia = useMobileMedia();

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <H2 as="h1">Congrats! Your domain is available.</H2>
        </div>
        <div className={styles.subheader}>1 year for $19.99 or 2 years for $39.98.</div>
        <div className={styles.formBody}>
          <FormRow>
            <FormColumn xs="12" md>
              <UnionField name="Domain" value={domainName} disabled />
            </FormColumn>
            <FormColumn xs="12" md="4">
              <Select label="TLD" disabled value={tld}>
                <Option value={tld}>{'.' + tld}</Option>
              </Select>
            </FormColumn>
          </FormRow>
          <Footer
            primaryOnClick={onConfirm}
            primaryText="Check out"
            secondaryOnClick={onCancel}
            secondaryText="Start over"
            showSpinner={false}
            buttonsSize={mobileMedia.yes ? 'sm' : 'lg'}
            footerContainerClassOverride={styles.footerContainerClassOverride}
          />
        </div>
      </div>
    </>
  );
};

export default MatchedDomain;
